import axios from 'axios';

const version = 'v1';
const basePath = 'warehouse';

export async function getAll() {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
    },
  });
}
